import { useLocation } from 'react-router-dom';

import { RoutePath, isNonDefaultPage } from '@/Routes/RoutePath';
import { Flags, useFeatureFlag } from './useFeatureFlags';

const useIsNonDefaultPage = () => {
  const location = useLocation();
  // this will enable the header and footer for the my hub page
  // if the package upgrade journey is disabled
  const { isOff: isPUJDisabled } = useFeatureFlag(Flags.PACKAGE_UPGRADE_JOURNEY);
  if (isPUJDisabled && location.pathname === RoutePath.myHub) return false;

  return isNonDefaultPage(location.pathname);
};

export default useIsNonDefaultPage;
